import React, {useRef, useState} from "react";
import { useAppDispatch, useAppSelector} from "../../DAL/store";
import {ProductModel} from "../../interfaces";
import {PlansPopup} from "./plans-popup";
import {PluginLg} from "./plugin-lg";
import {PluginViewLg} from "./plugin-view-lg";
import {HidePluginView, SortItems} from "../../services/logic-helper";


interface IPluginsPopupLgProps {

}

export const PluginsPopupLg = (props: IPluginsPopupLgProps) => {

    const PageData = useAppSelector((store) => store.PageData);
    const SearchFilterKey = useAppSelector((store) => store.SearchFilterKey);
    const PluginSortStatus = useAppSelector((store) => store.PluginSortStatus);
    const ShowPluginImageSortIncludesID = useAppSelector((store) => store.ShowPluginImageSortIncludesID);
    const PluginViewPosition = useAppSelector((store) => store.PluginViewPosition);
    const FilteredItems = PageData.products.filter(item => item.documentName.toLowerCase().includes(SearchFilterKey.toLowerCase()));
    const SortedAndFilteredItems = SortItems(FilteredItems,PluginSortStatus);
    const [showFadeBottom, setShowFadeBottom] = useState(true);

    const listInnerRef = useRef<any>();
    const dispatch = useAppDispatch();
    const OnScrollPlugins = () => {
        HidePluginView(dispatch);
        if (listInnerRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
            if (scrollTop + clientHeight + 10 >= scrollHeight) {
                //Reached bottom --> hide the fade div to display the last plugins in the list
                setShowFadeBottom(false);
            }else{
                if(!showFadeBottom){
                    //Scrolled up (out of the bottom) --> show the fade div
                    setShowFadeBottom(true);
                }
            }
        }
    }
    return (
            <div className="w-full text-white relative " style={{width:"1000px"}} onClick={() => HidePluginView(dispatch)}>
                <PlansPopup />
                <div className="w-full">
                    <ul className="w-full  px-2 xl:px-4 popup-plugins-items pb-8 " id="plugins-list-container"  onScroll={() => OnScrollPlugins()} ref={listInnerRef} >
                        {SortedAndFilteredItems.length > 0 && SortedAndFilteredItems.map((product : ProductModel, index: number) => {
                            return <PluginLg key={index} product={product} index={index} />
                        })}
                    </ul>

                </div>
                {ShowPluginImageSortIncludesID > 0  && PluginViewPosition !== null &&
                    <PluginViewLg product={SortedAndFilteredItems.filter(product => product.sortIncludes === ShowPluginImageSortIncludesID )[0]}  />
                }
                <div className={`linear-fade-bg-color ${showFadeBottom ? "block":"hidden"}`}>

                </div>
            </div>

    )
};